import { render, staticRenderFns } from "./ReadWrite_chat.vue?vue&type=template&id=d940a086&scoped=true&"
import script from "./ReadWrite_chat.vue?vue&type=script&lang=js&"
export * from "./ReadWrite_chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d940a086",
  null
  
)

export default component.exports